module.exports = __webpack_public_path__ + "img/pickup.f7043334.webp";